import React from "react";
import Card, { CardLabel, CardSub, CardUnit, CardValue } from "./Card";
import DeltaValue from "../DeltaValue/DeltaValue";

/**
 * Carte KPI simple : libellé + grande valeur + unité.
 * Si `section` est fourni, la valeur devient comparable ("vs précédent").
 */
const KpiCard = ({
    label,
    value,
    unit,
    sub,
    section,
    seed,
    delta,
    ...props
}) => {
    const isPct = unit === "%";
    return (
        <Card {...props}>
            <CardLabel>{label}</CardLabel>
            <CardValue>
                {section ? (
                    <DeltaValue
                        section={section}
                        seed={seed}
                        isPct={isPct}
                        delta={delta}
                    >
                        {value}
                    </DeltaValue>
                ) : (
                    value
                )}
                {unit && <CardUnit>{unit}</CardUnit>}
            </CardValue>
            {sub && <CardSub>{sub}</CardSub>}
        </Card>
    );
};

export default KpiCard;
